import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ProfilePicContainer = styled.div`
  border-radius: ${pxToRem('20px')};
  background-color: transparent;
  display: flex;
  align-content: flex-end;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;
export const CircleFrame = styled.div`
  width: ${pxToRem('48px')};
  height: ${pxToRem('48px')};
  border-radius: 100%;
  border: ${pxToRem('3px')} solid ${props => props.theme.colors.blue.one};
  box-shadow: 0 0 0 ${pxToRem('2px')}
    ${props => props.theme.colors.picTransparent} inset;
  background-color: ${props => props.theme.colors.white};
  margin-left: ${pxToRem('20px')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const CircleImage = styled.img`
  max-width: 50%;
`;
